import React from 'react';
import { Page } from '../Page';
import { Logo } from '../Logo';
export function Page1() {
  return <Page hideFooter variant="dark" data-id="element-264">
      {/* Full-bleed background image */}
      <div className="absolute inset-0 z-0" data-id="element-265">
        <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200&q=80" alt="Healthy meal preparation" className="w-full h-full object-cover" data-id="element-266" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/80 via-charcoal/60 to-charcoal/90" data-id="element-267" />
      </div>

      <div className="flex-1 flex flex-col justify-between relative z-10" data-id="element-268">
        {/* Top: Logo */}
        <div className="pt-4" data-id="element-269">
          <img src="https://cdn.magicpatterns.com/uploads/oG8aVK1qBACM4upmyDQtwJ/file_0000000081b8722fb80a3dcf6435ffdb__1_-removebg-preview.png" alt="Structured Nutrition logo" className="w-32 h-32 object-contain" data-id="element-270" />
        </div>

        {/* Center: Title */}
        <div className="flex-1 flex flex-col justify-center -mt-8" data-id="element-271">
          <div className="w-16 h-0.5 bg-tealslate mb-8" data-id="element-272" />
          <h1 className="font-serif text-6xl text-white leading-[1.15] mb-6" data-id="element-273">
            The GLP-1
            <br data-id="element-274" />
            <span className="text-lightteal" data-id="element-275">Nutrition</span>
            <br data-id="element-276" />
            Guide
          </h1>
          <p className="font-sans text-sm text-[#E5E5E5]/80 max-w-sm leading-[1.8] mb-10" data-id="element-277">
            Your essential guide to nutrition, supplements, and building
            sustainable habits on GLP-1 medication.
          </p>
        </div>

        {/* Bottom: Author */}
        <div className="pb-2" data-id="element-278">
          <div className="w-10 h-px bg-tealslate/60 mb-4" data-id="element-279" />
          <p className="font-sans text-xs text-[#9CA3AF] tracking-[0.15em] uppercase" data-id="element-280">
            By Jack Achenbach MS, RDN, CPT
          </p>
        </div>
      </div>
    </Page>;
}